import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, Select, MenuItem, Typography, CircularProgress, TablePagination, Divider, TableContainer, TableHead, TableBody, Table, Paper, TableRow, TableCell } from '@mui/material';

import { url } from 'src/apiUtils/apiPath';

import { appApi } from 'src/apiUtils/AppApi';
import { alpha, styled } from '@mui/material/styles';
import moment from 'moment';
// components
import { useChart } from '../../../components/chart';
import Scrollbar from '../../../components/scrollbar';
import config from '../../../AppConfig'



// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string
};

export default function AppWebsiteVisits({ title, subheader, borderColor = 'primary' }) {

  const [bookingData, setBookingData] = useState([])
  useEffect(() => {
    appApi(`${url.DASHBOARD_TODAY_BOOKING_DETAIL}`, "POST", {}, JSON.stringify({})).then((result) => {
      if (result.status) {
        setBookingData(result.data)
      }
    })
  }, [])
  return (
    <Card sx={{
      paddingLeft: 1,
      paddingRight: 1,
      paddingBottom: 1,
      height: 306,
      // boxShadow: (theme) => `${alpha(theme.palette[borderColor].dark, 0.07)} 0px 7px 29px 0px`,
      border: (theme) => `1px solid ${alpha(theme.palette[borderColor].dark, 0.24)}`
    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: "center",
        marginBottom: 2,
        color: (theme) => theme.palette[borderColor].dark,
      }}>
        <CardHeader title={title} subheader={subheader} />
      </Box>
      {bookingData && bookingData.length > 0 ?
        <Box>
          <TableContainer sx={{ maxHeight: 200 }}>
            <Table size="small" aria-label="a dense table" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left" width={'37.5%'}>{config.appUserType}</TableCell>
                  {/* <TableCell align="left" width={'25%'}>Date</TableCell> */}
                  <TableCell align="left" width={'25%'}>Slot Time</TableCell>
                  <TableCell align="left" width={'37.%'}>User Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bookingData && bookingData.length > 0 ? bookingData.map((list) => (
                  <TableRow>
                    <TableCell align="left" width={'37.5%'}>{list?.expertDetails.expertName ?? '--'}</TableCell>
                    <TableCell align="left" width={'25%'}>{list?.UTC_StartTime ? moment(list?.UTC_StartTime).format('hh a') : '--'} - {list?.UTC_EndTime ? moment(list?.UTC_EndTime).format('hh a') : '--'}</TableCell>
                    <TableCell align="left" width={'37.5%'}>{list?.usersDetails?.userName ?? '--'}</TableCell>
                    {/* <TableCell align="left" width={'25%'}>{list?.slotDate ? moment(list?.slotDate).format('DD MMM YYYY') : '--'}</TableCell> */}
                  </TableRow>)) :
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph color={'red'}>
                            {'No Data Found'}
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>}
              </TableBody>
            </Table>
          </TableContainer>


          {/* {bookingData && bookingData.length > 0 ? bookingData.map((list) => (<><Box sx={{ padding: 1 }}>
          <Typography>{`${list?.UTC_StartTime ? moment(list?.UTC_StartTime).format('hh a') : '--'} - ${list?.UTC_EndTime ? moment(list?.UTC_EndTime).format('hh a') : '--'} slot of ${list?.expertDetails?.expertName} been booked by the yyy`}</Typography>
          </Table>
          </TableContainer>
          </Scrollbar>
        </Box>)) : } */}
        </Box> :

        <Box display={"flex"} justifyContent={"center"} alignContent={'center'} sx={{ padding: 4 }}>
          <Typography sx={{ color: 'red' }}>No Bookings Found</Typography>
        </Box>}
    </Card >
  );
}
